import type { IconName } from '@/components/foundations';

/** Status de pagamento do lojista: único lugar com rótulo, título e ícone de cada um. */
export type PaymentStatus = 'ok' | 'warn' | 'err';

export const PAYMENT_STATUS: Record<PaymentStatus, { label: string; title: string; icon: IconName }> = {
  ok: { label: 'Aprovado', title: 'Pagamento aprovado', icon: 'checkc' },
  warn: { label: 'Pendente', title: 'Pagamento pendente', icon: 'clock' },
  err: { label: 'Recusado', title: 'Pagamento recusado', icon: 'x' },
};
